<template>
  <div class="yullbe-rooms">
    <template
      v-for="room in yullbeRooms"
    >
      <button
        v-if="selectedClass != room.cls"
        :key="room.cls"
        class="yullbe-room"
        @click="updateYullbeClass(room.cls)"
      >
        <div class="yullbe-room__info">
          <h3>{{ getLabel(`introduction.miwula_yullbe_teaser_${room.label}_head`) }}</h3>
          <p
            class="yullbe-room__infotext"
            v-html="getLabel(`introduction.miwula_yullbe_teaser_${room.label}`)"
          />
        </div>
        <img
          :src="getYullbeIcon(room.icon)"
          class="yullbe-room__logo"
        >
      </button>
      <div
        v-else
        :key="room.cls"
        class="yullbe-room-selected"
      >
        <h3>{{ room.backside_title }}</h3>
        <p v-html="getLabel(`introduction.miwula_yullbe_teaser_${room.label}_change`)" />
        <button
          class="action action--secondary-inverse-dark action--uppercase"
          @click="updateYullbeClass(null)"
        >
          <span class="action__inner">
            <c-icon
              type="chevron-left"
              :size="0.75"
            />
            {{ room.backside_button }}
          </span>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import CIcon from './icon.vue'
import { BASE_URL } from '../settings.js'

import labelMixin from '../mixins/label.js'

export default {
  name: 'CYullbeRooms',
  components: {
    CIcon
  },
  mixins: [labelMixin],
  computed: {
    yullbeRooms () {
      return [{
        backside_title: this.$t('yullbe_go.backside_title'),
        backside_button: this.$t('yullbe_go.backside_button'),
        label: 'go',
        icon: 'GO',
        cls: 0
      },
      {
        backside_title: this.$t('yullbe_pro.backside_title'),
        backside_button: this.$t('yullbe_pro.backside_button'),
        label: 'pro',
        icon: 'PRO',
        cls: 1
      }]
    },
    selectedClass () {
      return this.$store.state.yullbeSelectedClass
    }
  },

  methods: {
    getYullbeIcon (icon) {
      return `${BASE_URL}static/img/yullbe_${icon}.svg`
    },
    updateYullbeClass (cls) {
      this.$store.commit('yullbeClassSelected', cls)
    }
  }
}
</script>

<i18n locale="en">
{
  "yullbe_go": {
    "title": "YULLBE GO",
    "text": "The 10-minute Single Player Virtual Reality Experience",
    "backside_title": "Want to book YULLBE PRO instead?",
    "backside_text": "Lorem ipsum",
    "backside_button": "Change selection"
  },
  "yullbe_pro": {
    "title": "YULLBE PRO",
    "text": "The 30-minute complete YULLBE-Experience for groups up to 6 people",
    "backside_title": "Want to book YULLBE GO instead??",
    "backside_text": "Lorem ipsum",
    "backside_button": "Change selection"
  }
}
</i18n>

<i18n locale="de">
{
  "yullbe_go": {
    "title": "YULLBE GO",
    "text": "Das 10-minütige VR-Erlebnis für Einzelspieler",
    "backside_title": "Sie möchten doch YULLBE PRO Buchen?",
    "backside_text": "Lorem ipsum",
    "backside_button": "Auswahl ändern"
  },
  "yullbe_pro": {
    "title": "YULLBE PRO",
    "text": "Das 30-minütige volle VR-Erlebnis für Gruppen bis zu 8 Personen",
    "backside_title": "Sie möchten doch YULLBE GO Buchen?",
    "backside_text": "Lorem ipsum",
    "backside_button": "Auswahl ändern"
  }
}
</i18n>

<style lang="scss">
  @import "../css/variables";

  .yullbe-rooms {
    display: grid;

    @media (min-width: $breakpoint-sidebar-min) {
      grid-template-columns: 1fr 1fr;
    }

    gap: 1em;
  }

  .yullbe-room {
    background-color: #000;
    color: #fff;

    text-align: left;
    border: 0;
    line-height: 1.5;

    padding: 2em;

    border-radius: 1em;

    display: grid;

    grid-template-columns: 2fr 1fr;
  }

  .yullbe-room__info {
    font-weight: 500;
  }

  .yullbe-room__info h3 {
    font-size: 1.4em;
  }

  .yullbe-room__infotext {
    font-style: italic;
  }

  .yullbe-room-selected {
    background-color: $color-background;
    border: 0.125em solid $color-muted;

    border-radius: 1em;
    padding: 2em;
  }
</style>
